import { mergeStyles } from 'src/_shared/utils/mergeStyles';
import { IconButtonProps, IconButtonPersonalizedStyles } from './IconButton.types';

export function withPersonalizedIconButtonStyle<T extends IconButtonProps>(
  Component: React.ComponentType<T & IconButtonPersonalizedStyles>,
  styles: IconButtonPersonalizedStyles,
) {
  return ({
    style,
    innerStyle,
    disabledStyle,
    focusStyle,
    hoverStyle,
    pressedStyle,
    iconStyle,
    iconDisabledStyle,
    iconFocusStyle,
    iconHoverStyle,
    iconPressedStyle,
    ...props
  }: T) => {
    return (
      <Component
        style={mergeStyles(styles.button, style)}
        innerStyle={mergeStyles(styles.buttonInner, innerStyle)}
        disabledStyle={mergeStyles([styles.buttonDisabled, disabledStyle])}
        focusStyle={mergeStyles([styles.buttonFocus, focusStyle])}
        hoverStyle={mergeStyles([styles.buttonHover, hoverStyle])}
        pressedStyle={mergeStyles([styles.buttonPressed, pressedStyle])}
        iconStyle={mergeStyles(styles.icon, iconStyle)}
        iconDisabledStyle={mergeStyles([styles.iconDisabled, iconDisabledStyle])}
        iconFocusStyle={mergeStyles([styles.iconFocus, iconFocusStyle])}
        iconHoverStyle={mergeStyles([styles.iconHover, iconHoverStyle])}
        iconPressedStyle={mergeStyles([styles.iconPressed, iconPressedStyle])}
        {...props}
      />
    );
  };
}
